import { render, staticRenderFns } from "./WidgetAdd.vue?vue&type=template&id=47d452a3&"
import script from "./WidgetAdd.vue?vue&type=script&lang=ts&"
export * from "./WidgetAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports